<template>
  <div>
    <builderall-banner
      :title='toolInfo.name'
      :subtitle='toolInfo.title'
      :description=' toolInfo.subtitle'
    ></builderall-banner>

    <!-- Content -->
    <div class='ba-app-wrapper ba-gp-1'>
      <div class='ba-sidebar'>
        <ul class='ba-nav'>
          <li v-for="(r, i) in toolInfo.routes" class='ba-nav-item'>
            <a :href='r.url' class='ba-link ba-is-active'>
              <img class="route-icon" :src="r.icon" >
              <span class='ba-title'>{{ r.title }}</span>
            </a>
          </li>
        </ul>
        <div class='ba-bottom'>
          <div class='ba-overview d-none'>
            <div class='ba-video-thumb'>
              <img src='https://placehold.co/159x107/000000/AAAAAA' alt='Overview Tools Name'>
              <button class='ba-button'>
                <svg xmlns='http://www.w3.org/2000/svg' width='16' height='16' fill='currentColor' class='bi bi-arrows-angle-expand' viewBox='0 0 16 16'>
                  <path fill-rule='evenodd' d='M5.828 10.172a.5.5 0 0 0-.707 0l-4.096 4.096V11.5a.5.5 0 0 0-1 0v3.975a.5.5 0 0 0 .5.5H4.5a.5.5 0 0 0 0-1H1.732l4.096-4.096a.5.5 0 0 0 0-.707zm4.344-4.344a.5.5 0 0 0 .707 0l4.096-4.096V4.5a.5.5 0 1 0 1 0V.525a.5.5 0 0 0-.5-.5H11.5a.5.5 0 0 0 0 1h2.768l-4.096 4.096a.5.5 0 0 0 0 .707z'/>
                </svg>
              </button>
            </div>
            <span class='ba-title'>Overview Tools Name </span>
            <span class='ba-description'>Here we can insert a text with a written 3-line rule that better justifies the concept of the tool in use and not exceed.</span>
            <button class='ba-btn ba-sm ba-blue ba-w-100'>
              More Info
              <svg xmlns='http://www.w3.org/2000/svg' width='10' height='10' fill='#fff' class='bi bi-arrow-up-right' viewBox='0 0 16 16'>
                <path fill-rule='evenodd' d='M14 2.5a.5.5 0 0 0-.5-.5h-6a.5.5 0 0 0 0 1h4.793L2.146 13.146a.5.5 0 0 0 .708.708L13 3.707V8.5a.5.5 0 0 0 1 0v-6z'/>
              </svg>
            </button>
          </div>
          <ul class='ba-bottom-list'>
            <li>
              <builderall-help></builderall-help>
            </li>
          </ul>
        </div>
      </div>
      <div class='ba-container ba-flex ba-gp-1 ba-ai-baseline ba-jc-center ba-f-wrap'>
        <div class='ba-card ba-w-100 m-h'>
          <slot />
        </div>
      </div>
      <div class='ba-footer'>
        <builderall-footer></builderall-footer>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "tools-layout-component",
  props: {
    view: {
      type: [Array, Object],
      required: false
    }
  },
  data() {
    return {
      toolInfo: {
        name: 'tool name',
        title: 'Title',
        subtitle: 'Subtitle',
        banner: '',
        icon: ''
      }
    }
  },
  mounted() {
    console.log('Aqui')
    this.toolInfo = this.view
    this.setBanner()
  },
  methods: {
    setBanner() {
      $('.ba-banner').css('background-image', `url(${this.toolInfo.banner})`);
    }
  }
}
</script>
<style>
.ba-app-content, #wrapper {
  height: auto !important;
  max-height: calc(100% - 80px);
}
.ba-app-content {
  overflow-y: hidden !important;
}
#wrapper {
  overflow-y: scroll !important;
}
.banner {
  position: absolute;
  width: 100%;
  height: 256px;
  margin: -1.8rem;
}
.m-h {
  min-height: 35rem;
}
.route-icon {
  width: 25px;
  height: 25px;
}
.d-none {
  display: none !important;
}
* {
  font-family: Montserrat;
}
</style>



// WEBPACK FOOTER //
// resources/office/js/layouts/ToolsLayoutComponent.vue